export const mockFuelScales = {
  fuelScales: [
    {
      id: 4197,
      code: "17881",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "NATIONAL",
      fuelPriceValue: 3.62,
      status: "Active",
    },
    {
      id: 4198,
      code: "17882",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD5",
      fuelPriceValue: 3.62,
      status: "Active",
    },
    {
      id: 4199,
      code: "17883",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "PADD4",
      fuelPriceValue: 3.62,
      status: "Active",
    },
    {
      id: 4200,
      code: "17884",
      longDescription: "Nati Diesel Average Effective Following Monday",
      fuelPrice: "PADD4",
      fuelPriceValue: 3.62,
      status: "Active",
    },
    {
      id: 4201,
      code: "17885",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD3",
      fuelPriceValue: 3.62,
      status: "Draft",
    },
    {
      id: 4202,
      code: "17886",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "NATIONAL",
      fuelPriceValue: 3.62,
      status: "Active",
    },
    {
      id: 4203,
      code: "17887",
      longDescription: "Nati Diesel Average Effective",
      fuelPrice: "PADD4",
      fuelPriceValue: 3.62,
      status: "Inactive",
    },
    {
      id: 4204,
      code: "17888",
      longDescription: "Nati Diesel Average Effective Following Monday",
      fuelPrice: "PADD4",
      fuelPriceValue: 3.62,
      status: "Inactive",
    },
    {
      id: 4205,
      code: "17889",
      longDescription: "Last Diesel Monday of Month Effective Following Month",
      fuelPrice: "PADD3",
      fuelPriceValue: 3.62,
      status: "Active",
    },
    {
      id: 4192,
      code: "17890",
      longDescription: "PaddV Average of Monday Effective Wednesday",
      fuelPrice: "NATIONAL",
      fuelPriceValue: 3.62,
      status: "Draft",
    },
  ],
  pagination: {
    totalRecords: 10,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
  },
  // Common accounts data used for all fuel scale codes
  commonAccounts: [
    {
      accountId: 1001,
      accountName: "ABC Logistics Inc",
      accountNumber: "ACC001",
    },
    {
      accountId: 1002,
      accountName: "XYZ Transport Co",
      accountNumber: "ACC002",
    },
    {
      accountId: 1003,
      accountName: "Global Shipping LLC",
      accountNumber: "ACC003",
    },
    {
      accountId: 1004,
      accountName: "Fast Freight Systems",
      accountNumber: "ACC004",
    },
    {
      accountId: 1005,
      accountName: "Regional Delivery Services",
      accountNumber: "ACC005",
    },
    {
      accountId: 1006,
      accountName: "West Coast Logistics",
      accountNumber: "ACC101",
    },
    {
      accountId: 1007,
      accountName: "Pacific Transport",
      accountNumber: "ACC102",
    },
    {
      accountId: 1008,
      accountName: "Mountain Express",
      accountNumber: "ACC103",
    },
    {
      accountId: 1009,
      accountName: "Monthly Shipping Co",
      accountNumber: "ACC201",
    },
    {
      accountId: 1010,
      accountName: "Regular Freight Inc",
      accountNumber: "ACC202",
    },
    {
      accountId: 1011,
      accountName: "Standard Logistics",
      accountNumber: "ACC203",
    },
    {
      accountId: 1012,
      accountName: "Monthly Express",
      accountNumber: "ACC204",
    },
    {
      accountId: 1013,
      accountName: "Consistent Transport",
      accountNumber: "ACC205",
    },
    {
      accountId: 1014,
      accountName: "Steady Shipping LLC",
      accountNumber: "ACC206",
    },
    {
      accountId: 1015,
      accountName: "Weekly Express Inc",
      accountNumber: "ACC301",
    },
    {
      accountId: 1016,
      accountName: "Fast Weekly Shipping",
      accountNumber: "ACC302",
    },
    {
      accountId: 1017,
      accountName: "Weekly Logistics Co",
      accountNumber: "ACC303",
    },
    {
      accountId: 1018,
      accountName: "Rapid Weekly Transport",
      accountNumber: "ACC304",
    },
    {
      accountId: 1019,
      accountName: "Quarterly Logistics Inc",
      accountNumber: "ACC401",
    },
    {
      accountId: 1020,
      accountName: "Quarterly Transport Co",
      accountNumber: "ACC402",
    },
  ],
};

export const mockServiceLevelOptions = [
  { id: 3, code: "LTL", description: "Standard LTL Freight" },
  { id: 1, code: "LTL-CC", description: "LTL Critical Care Freight" },
  { id: 2, code: "LTL-UC", description: "LTL Urgent Care Freight" },
  { id: 5, code: "AIR", description: "Air Freight" },
  { id: 4, code: "VOLUME", description: "Volume Freight" },
  { id: 6, code: "TRUCKLOAD", description: "Truckload Freight" },
];

export const mockFuelAverages = {
  fuelAverages: [
    {
      id: 1,
      fuelAverageCode: "NATIONAL",
      fuelAverageDescription: "National Average",
      effectiveDate: "2024-01-01",
      currentPrice: "3.62",
    },
    {
      id: 2,
      fuelAverageCode: "PADDV",
      fuelAverageDescription: "PADD V Average",
      effectiveDate: "2024-01-01",
      currentPrice: "3.58",
    },
    {
      id: 3,
      fuelAverageCode: "LINEHAUL",
      fuelAverageDescription: "Linehaul Average",
      effectiveDate: "2024-01-01",
      currentPrice: "3.65",
    },
  ],
};

// Mock detailed fuel surcharge code data
// Each entry uses the fuel scale ID as key and matches the FuelSurchargeCodeFormData type
export const mockFuelSurchargeCodeDetails: Record<
  number,
  {
    code?: string;
    shortDescription: string;
    longDescription: string;
    fuelAverage: string;
    serviceLevel: string[];
    notActive: boolean;
    interlinerCharges: boolean;
    autoAssignByDefault: boolean;
    criteriaId?: number;
    rates: Array<{
      priceFrom: number | null;
      priceTo: number | null;
      percentage: number | null;
    }>;
  }
> = {
  4197: {
    code: "FuelChg",
    shortDescription: "Fuel Surcharge",
    longDescription: "Fuel Surcharge",
    fuelAverage: "National",
    serviceLevel: ["LTL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: true,
    criteriaId: 12,
    rates: [
      { priceFrom: 1.69, priceTo: 1.699, percentage: 17.2 },
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17.3 },
      { priceFrom: 1.8, priceTo: 1.899, percentage: 17.4 },
      { priceFrom: 1.9, priceTo: 1.999, percentage: 17.5 },
      { priceFrom: 2.0, priceTo: 2.099, percentage: 17.6 },
    ],
  },
  4198: {
    code: "FuelChgWst",
    shortDescription: "Regional West Fuel",
    longDescription: "Regional West Fuel",
    fuelAverage: "PADDV",
    serviceLevel: ["LTL", "TL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: true,
    criteriaId: 13,
    rates: [
      { priceFrom: 1.5, priceTo: 1.599, percentage: 15.5 },
      { priceFrom: 1.6, priceTo: 1.699, percentage: 16.5 },
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17.5 },
    ],
  },
  4199: {
    code: "FuelAlt001",
    shortDescription: "Alternative Fuel 001",
    longDescription: "Alternative Fuel 001",
    fuelAverage: "National",
    serviceLevel: ["LTL"],
    notActive: false,
    interlinerCharges: false,
    autoAssignByDefault: true,
    criteriaId: 14,
    rates: [
      { priceFrom: 1.6, priceTo: 1.699, percentage: 16 },
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17 },
      { priceFrom: 1.8, priceTo: 1.899, percentage: 18 },
    ],
  },
  4200: {
    code: "FuelAlt002",
    shortDescription: "Alternative Fuel 002",
    longDescription: "Alternative Fuel 002",
    fuelAverage: "LINEHAUL",
    serviceLevel: ["LTL", "TL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: true,
    criteriaId: 15,
    rates: [
      { priceFrom: 1.5, priceTo: 1.599, percentage: 15 },
      { priceFrom: 1.6, priceTo: 1.699, percentage: 16 },
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17 },
      { priceFrom: 1.8, priceTo: 1.899, percentage: 18 },
    ],
  },
  4201: {
    code: "Fuel-02",
    shortDescription: "Fuel Surcharge 02",
    longDescription: "Fuel Surcharge 02",
    fuelAverage: "National",
    serviceLevel: ["LTL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: true,
    criteriaId: 16,
    rates: [
      { priceFrom: 1.69, priceTo: 1.699, percentage: 17.2 },
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17.3 },
      { priceFrom: 1.8, priceTo: 1.899, percentage: 17.4 },
    ],
  },
  4202: {
    code: "FuelW-02",
    shortDescription: "West Fuel 02",
    longDescription: "West Fuel 02",
    fuelAverage: "PADDV",
    serviceLevel: ["LTL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: false,
    criteriaId: 17,
    rates: [
      { priceFrom: 1.5, priceTo: 1.599, percentage: 15 },
      { priceFrom: 1.6, priceTo: 1.699, percentage: 16 },
    ],
  },
  4203: {
    code: "Fuel-03",
    shortDescription: "Fuel Surcharge 03",
    longDescription: "Fuel Surcharge 03",
    fuelAverage: "National",
    serviceLevel: ["LTL", "TL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: true,
    criteriaId: 18,
    rates: [
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17 },
      { priceFrom: 1.8, priceTo: 1.899, percentage: 18 },
      { priceFrom: 1.9, priceTo: 1.999, percentage: 19 },
    ],
  },
  4204: {
    code: "FuelW-03",
    shortDescription: "West Fuel 03",
    longDescription: "West Fuel 03",
    fuelAverage: "PADDV",
    serviceLevel: ["LTL"],
    notActive: false,
    interlinerCharges: false,
    autoAssignByDefault: true,
    criteriaId: 19,
    rates: [
      { priceFrom: 1.6, priceTo: 1.699, percentage: 16.5 },
      { priceFrom: 1.7, priceTo: 1.799, percentage: 17.5 },
    ],
  },
  4205: {
    code: "Fuel-04",
    shortDescription: "Fuel Surcharge 04",
    longDescription: "Fuel Surcharge 04",
    fuelAverage: "National",
    serviceLevel: ["LTL", "TL", "Express"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: true,
    criteriaId: 20,
    rates: [
      { priceFrom: 1.8, priceTo: 1.899, percentage: 18 },
      { priceFrom: 1.9, priceTo: 1.999, percentage: 19 },
      { priceFrom: 2.0, priceTo: 2.099, percentage: 20 },
    ],
  },
  4192: {
    code: "FuelThu001",
    shortDescription: "Thursday Fuel 001",
    longDescription: "Thursday Fuel 001",
    fuelAverage: "TUESWED",
    serviceLevel: ["LTL"],
    notActive: false,
    interlinerCharges: true,
    autoAssignByDefault: false,
    criteriaId: 21,
    rates: [
      { priceFrom: 1.4, priceTo: 1.499, percentage: 14 },
      { priceFrom: 1.5, priceTo: 1.599, percentage: 15 },
    ],
  },
};
